var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-companion-box",
      class: [_vm.mood],
    },
    [
      _c(
        "div",
        [
          _c("p", {
            domProps: {
              innerHTML: _vm._s(_vm.msgCompanion),
            },
          }),
          _vm._v(" "),
          _vm._t("companionActions"),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }